/**
 * Per-user staff-sidebar collapse. localStorage only — `user_ui_preferences`
 * has no sidebar column, and adding one would need a migration.
 *
 * Reuses the pre-Design-V2 key `clinio-v2-sidebar-collapsed` (removed in #106),
 * now scoped as `clinio-v2-sidebar-collapsed:<userId>`. The unscoped key is
 * still read as a fallback so a collapse choice from before the UI update
 * is remembered. Admin uses a separate key (`clinio-v2-admin-sidebar-collapsed`).
 */

export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'clinio-v2-sidebar-collapsed';

export function sidebarCollapsedStorageKey(userId: string): string {
  return `${SIDEBAR_COLLAPSED_STORAGE_KEY}:${userId}`;
}

function readFlag(key: string): boolean | null {
  try {
    const raw = localStorage.getItem(key);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return null;
  } catch {
    return null;
  }
}

export function readSidebarCollapsed(userId: string | null | undefined): boolean {
  if (userId) {
    const scoped = readFlag(sidebarCollapsedStorageKey(userId));
    if (scoped !== null) return scoped;
  }
  return readFlag(SIDEBAR_COLLAPSED_STORAGE_KEY) === true;
}

export function writeSidebarCollapsed(userId: string | null | undefined, collapsed: boolean): void {
  try {
    if (userId) {
      localStorage.setItem(sidebarCollapsedStorageKey(userId), String(collapsed));
      return;
    }
    localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, String(collapsed));
  } catch {
    // localStorage not available
  }
}
